export var calculateFitToPreviewPxSize = function (_a) {
    var layoutSize = _a.layoutSize, previewSize = _a.previewSize, customSize = _a.customSize;
    if (!layoutSize || !previewSize) {
        return '0px';
    }
    customSize = ("" + customSize).includes('px') ? +customSize.split('px')[0] : +customSize;
    previewSize = +previewSize;
    if (customSize < 0) {
        return '0px';
    }
    var newValue = Math.round((customSize / layoutSize) * previewSize);
    return newValue + "px";
};
export var convertObjectToCss = function (object) {
    var css = Object.keys(object).map(function (selector) {
        var definition = object[selector];
        var rules = Object.keys(definition);
        var result = rules.map(function (rule) { return rule + ":" + definition[rule]; }).join(';');
        return selector + "{" + result + "}";
    }).join('\n');
    return css;
};
//# sourceMappingURL=index.js.map